interface Entitlement {
  isSubscriber: boolean
  latestSubscriptionExpiresAt: string | null
}

interface RewardLockInput {
  /**
   * Typed as string, not the config union: stale activity data can still
   * carry legacy values ('pass', 'pass_subscription'), which must gate like
   * 'subscription' — never unlock.
   */
  unlockCondition: string
  claimableCreatedAt: string | null
}

export function isRewardLocked(
  reward: RewardLockInput,
  entitlement: Entitlement | undefined,
): boolean {
  if (!entitlement) return true
  if (reward.unlockCondition === 'free') return false
  return !entitlement.isSubscriber && !isInGracePeriod(reward, entitlement)
}

function isInGracePeriod(
  reward: RewardLockInput,
  entitlement: Entitlement,
): boolean {
  const expiresAt = entitlement.latestSubscriptionExpiresAt
  if (!expiresAt || !reward.claimableCreatedAt) return false
  return new Date(reward.claimableCreatedAt) <= new Date(expiresAt)
}
